interface ScreenReaderAnnouncerProps {
  message: string;
}

export function ScreenReaderAnnouncer({ message }: ScreenReaderAnnouncerProps) {
  return (
    <div
      role="status"
      aria-live="assertive"
      aria-atomic="true"
      className="sr-only"
      data-testid="screen-reader-announcer"
    >
      {message}
    </div>
  );
}
